export default function Colors(props) {
    const { input, setInput, user } = props;
    
    function handleColorChange(event) {
        const { name, value } = event.target;
        const index = parseInt(name, 10); // Get the index from the name attribute
        
        setInput(prevInput => ({
            ...prevInput,
            highlightColors: prevInput.highlightColors.map((color, i) => 
                i === index ? value : color // Only update the color at the specific index
            )
        }));
    }

    function setToDefault() {
        setInput(prevInput => ({
            ...prevInput,
            highlightColors: ['transparent', '#ffffff', '#cccccc', '#999999', '#666666', '#333333', 
                '#000000', '#ffb3b3', '#ffd9b3', '#ffffb3', '#b3ffb3', '#b3ffff', '#b3b3ff', 
                '#ffb3ff', '#ff6666', '#ffb366', '#ffff66', '#66ff66', '#66ffff', '#6666ff', 
                '#ff66ff', '#ff3333', '#ff9933', '#ffff33', '#33ff33', '#33ffff', '#3333ff', 
                '#ff33ff', '#ff0000', '#ff8000', '#ffff00', '#00ff00', '#00ffff', '#0000ff', 
                '#ff00ff', '#cc0000', '#cc6600', '#cccc00', '#00cc00', '#00cccc', '#0000cc', 
                '#cc00cc', '#800000', '#804000', '#808000', '#008000', '#008080', '#000080', 
                '#800080']
        }));
    }

    function setToPrevious() {
        setInput(prevInput => ({
            ...prevInput,
            highlightColors: JSON.parse(user.highlight_colors.replace(/'/g, '"'))
        }));
    }

    return(
        <div id="colors-select"><>highlight colours:</>
            <div id="colors-display-container">
                <div id="colors-display">
                    {input.highlightColors.map((item, index) => {
                        return (
                            <input
                                key={index}
                                name={`${index}`} 
                                onChange={handleColorChange} 
                                value={input.highlightColors[index]} 
                                placeholder="colour" 
                                readOnly={index === 0 ? true : false}
                                type={index === 0 ? "text" : "color"}
                            />
                        )
                    })}
                </div>
            </div>
            <div id="colors-select-actions">
                <button className="settings-button" onClick={setToDefault}>reset to default</button>
                <button className="settings-button" onClick={setToPrevious}> reset to previous values</button>
            </div>
        </div>
    );
}